import Swiper from 'swiper/bundle';

export default class GallerySlider {
    ready() {
        const CONTAINERS = document.querySelectorAll('.mtt-gallery-slider .swiper-container');

        CONTAINERS.forEach((container) => {
            new Swiper(container, {
                containerModifierClass: 'swiper-container-',
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 0,
                freeMode: false,
                watchOverflow: true,
                preloadImages: false,
                lazyPreloadPrevNext: 1,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
            });
        });
    }
}
